import React, { ChangeEvent } from 'react';
import { formatDate, isValid, parse } from 'date-fns';

import { defaultDateFormat } from '@constants/general';
import { useMask } from '@react-input/mask';
import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

interface IProps extends IFormFieldProps {
  dateFormat?: string;
}

function FormDateField({ name, label, optional, dateFormat = defaultDateFormat, size = 50 }: IProps) {
  const { id, fieldProps, inputProps, meta, setValue } = useFormField(name, size);

  const dateMask = dateFormat.toUpperCase();
  const inputRef = useMask({
    mask: dateMask,
    replacement: { D: /\d/, M: /\d/, Y: /\d/ },
    modify: (value) => ({ showMask: value !== undefined && value !== '' && value !== dateMask }),
  });

  const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const date = parse(event.target.value, dateFormat, new Date());
    await setValue(isValid(date) && date);
  };

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <input
        ref={inputRef}
        placeholder={dateMask}
        {...inputProps}
        value={inputRef.current?.value ?? (meta.value && formatDate(meta.value, dateFormat)) ?? ''}
        onChange={onChange}
      />
    </div>
  );
}

export default FormDateField;
